
document.addEventListener('DOMContentLoaded', function () {
  const sortSelect = document.getElementById('sortPosts');
  const container = document.querySelector('.blog-articles');
  let articles = Array.from(container.children);
  

  function sortArticles(criteria) {
    let sorted;

    if (criteria === 'latest') {
      sorted = articles.sort((a, b) => b.dataset.date - a.dataset.date);
    } else if (criteria === 'oldest') {
      sorted = articles.sort((a, b) => a.dataset.date - b.dataset.date);
    } else if (criteria === 'title-asc') {
      sorted = articles.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title));
    } else if (criteria === 'title-desc') {
      sorted = articles.sort((a, b) => b.dataset.title.localeCompare(a.dataset.title));
    }

    // Re-append articles in sorted order
    sorted.forEach(article => container.appendChild(article));
  }

  sortSelect.addEventListener('change', function () {
    sortArticles(this.value);
  });

  // Default sort on page load
  sortArticles('latest');
});






$( document ).ready(function() {
  window.products_on_page = $('.blog-articles');
  window.next_url = products_on_page.data('next-url');
  
  window.load_more_btn = $('.load-more__btn');
  window.load_more_spinner = $('.load-more__spinner');
  
});



function loadMoreProducts() { 
  
 $.ajax(
 
   {
 
     url: next_url,
     type: 'GET',
     dataType: 'html',
     beforeSend: function() {
      
       load_more_btn.hide();
       load_more_spinner.show();
       
     }
 
   }
 
 ).done(function(next_page) {
 
   load_more_spinner.hide();
 
 var new_products = $(next_page).find('.blog-articles');
   
 var new_url = new_products.data('next-url');
     
 next_url = new_url;
   
   
 if(new_url)
   load_more_btn.show();
   
 products_on_page.append(new_products.html());  
 
 
 
 }
 
 
 ) 
  
  
}